'use strict';

import { PERMISSIONS } from './Permissions';
import PermissionsTypes from './PermissionsTypes';

const { CREATE, READ, UPDATE, DELETE } = PermissionsTypes;

const INTRANET = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CONSULTATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
};

// à renommer en smart campaign
const MARKETING = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.CAMPAIGNS_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
};

// à renommer en sales intelligence
const SALES = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY_ENTRY_POINTS]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ENGAGE_BY_EMAIL]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.SEQUENCES]: [READ],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.LINKEDIN]: [READ],
};

const SALES_AUTOMATION = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ENGAGE_BY_EMAIL]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.SEQUENCES]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.LINKEDIN]: [READ],
};

// anciennement NEWS
const KAM = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY_ENTRY_POINTS]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CAMPAIGNS_DRAFT]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CONSULTATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUEST_HELP]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.SEQUENCES]: [READ],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
};

const SEARCH_AND_LISTS = {
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
};

const SALES_PME = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ENGAGE_BY_EMAIL]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.SEQUENCES]: [READ],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
};

const INSIGHT = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CONSULTATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
};

const SENDER = {
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
};

const SMART_DATA = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY_ENTRY_POINTS]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CONSULTATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ],
  [PERMISSIONS.SEQUENCES]: [READ],
};

const SALES_AUTOMATION_V2 = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY_ENTRY_POINTS]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],

  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],

  [PERMISSIONS.ADVANCED_SEARCH]: [READ],

  [PERMISSIONS.BUSINESS_ALERTS]: [READ],

  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ENGAGE_BY_EMAIL]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],

  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MY_PROSPECTS]: [READ],

  [PERMISSIONS.CAMPAIGNS]: [READ],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ],

  [PERMISSIONS.SEQUENCES]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_SETTINGS]: [CREATE, READ, UPDATE, DELETE],

  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.LINKEDIN]: [READ],
};

const SMART_CAMPAIGN_V2 = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.HOME_PROFILE]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],

  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],

  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],

  [PERMISSIONS.ADVANCED_SEARCH]: [READ],

  [PERMISSIONS.CAMPAIGNS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.CAMPAIGNS_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],

  [PERMISSIONS.SEQUENCES]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_SETTINGS]: [CREATE, READ, UPDATE, DELETE],

  [PERMISSIONS.PERSONAL_SPACE_MY_NETWORK]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS_ALL]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_LOCATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
};

const SALES_AND_MARKETING_V2 = {
  [PERMISSIONS.ACCOUNT_PAGE]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_ADD_ACCOUNT_TO_SEGMENTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_ADVERTISING]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_CONTACTS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_LEGAL]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_NEWS]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUBSIDIARIES]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY]: [READ],
  [PERMISSIONS.ACCOUNT_PAGE_TAB_SUMMARY_ENTRY_POINTS]: [READ],
  [PERMISSIONS.ADVANCED_SEARCH]: [READ],
  [PERMISSIONS.BUSINESS_ALERTS]: [READ],
  [PERMISSIONS.CONFERENCES]: [READ],
  [PERMISSIONS.CONTACT_PAGE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_ADD_TO_SEGMENT]: [READ],
  [PERMISSIONS.CONTACT_PAGE_COMMENTS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_CONTACT_DETAILS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_INTERACTIONS]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_HISTORY]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_OTHER_MANDATES]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TAB_PROFILE]: [READ],
  [PERMISSIONS.CONTACT_PAGE_TASKS]: [READ],
  [PERMISSIONS.HOME_HELP]: [READ],
  [PERMISSIONS.HOME_NEWS]: [READ],
  [PERMISSIONS.HOME_PROSPECT]: [READ],
  [PERMISSIONS.MY_PROSPECTING_MANAGER_ACCESS]: [READ],
  [PERMISSIONS.MY_PROSPECTING_SMART_SCORING]: [READ],
  [PERMISSIONS.NAVBAR_PROSPECTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_SAVED_SEARCHES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PROFILE_AND_AI]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_ACCOUNT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_SEGMENTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ALERTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CONTACT_CUSTOMER_SERVICE]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CAMPAIGN]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_CONSULTATION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_DASHBOARD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_NOTIFICATIONS_SETTINGS]: [READ],
  [PERMISSIONS.QUICK_SEARCH]: [READ],
  [PERMISSIONS.QUICK_SEARCH_ALL_RESULTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_COMPANIES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONFERENCES]: [READ],
  [PERMISSIONS.QUICK_SEARCH_CONTACTS]: [READ],
  [PERMISSIONS.QUICK_SEARCH_NEWS]: [READ],
  [PERMISSIONS.CAMPAIGNS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.CAMPAIGNS_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SCHEDULED]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SENT]: [READ, UPDATE],
  [PERMISSIONS.CAMPAIGNS_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.SEQUENCES_DRAFT]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PROGRAMMED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ONGOING]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_PAUSED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_FINISHED]: [READ, UPDATE],
  [PERMISSIONS.SEQUENCES_ARCHIVED]: [READ],
  [PERMISSIONS.SEQUENCES_SETTINGS]: [CREATE, READ, UPDATE, DELETE],
  [PERMISSIONS.CONTACT_PAGE_SEQUENCES]: [READ],
};

const SENDER_V2 = {
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_EMAIL_CONNECTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_PARAMETERS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_REQUESTS]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_TEMPLATES]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
};

const CONNECTOR = {
  [PERMISSIONS.PERSONAL_SPACE_ACTIVITY]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CREDIT_CONSUMPTION_EXPORT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_MY_ACCOUNT]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_CHANGE_PASSWORD]: [READ],
  [PERMISSIONS.PERSONAL_SPACE_LOGOUT]: [READ],
};

export {
  CONNECTOR,
  INSIGHT,
  INTRANET,
  KAM,
  MARKETING,
  SALES,
  SALES_AND_MARKETING_V2,
  SALES_AUTOMATION,
  SALES_AUTOMATION_V2,
  SALES_PME,
  SEARCH_AND_LISTS,
  SENDER,
  SMART_CAMPAIGN_V2,
  SMART_DATA,
  SENDER_V2,
};
